@if (visible()) {
<div class="card card-details shadow-sm border-0 sales-contact-card">
  <img
    src="assets/img/images/Illustration.png"
    alt=""
    class="card-illustration"
    aria-hidden="true"
  />

  <div class="card-body d-flex flex-column gap-2">
    <h6 class="notice-title mb-1">
      {{ "admin.projectIdeas.salesContactCard.noContactTitle" | translate }}
    </h6>
    <p class="notice-subtitle mb-2">
      {{
        "admin.projectIdeas.salesContactCard.noContactDescription" | translate
      }}
    </p>

    <button
      type="button"
      class="btn btn-primary btn-sm btn-fit d-inline-flex align-items-center gap-2"
      (click)="openDialog()"
    >
      <i class="fas fa-user-plus"></i>
      <span>{{
        "admin.projectIdeas.salesContactCard.assignButton" | translate
      }}</span>
    </button>
  </div>
</div>
}

<!-- Dialog  -->
@if (dialogOpen()) {
<div class="modal-backdrop fade show"></div>

<div
  class="modal modal-center d-block"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">
          {{ "admin.projectIdeas.salesContactCard.title" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="closeDialog()"
        ></button>
      </div>

      <div class="modal-body">
        <label class="form-label">
          {{ "admin.projectIdeas.salesContactCard.label" | translate }}
        </label>

        <select
          class="form-select"
          [ngModel]="selectedContactId()"
          (ngModelChange)="onModelChange($event)"
        >
          <option [ngValue]="null" disabled selected>
            {{ "admin.projectIdeas.salesContactCard.placeholder" | translate }}
          </option>
          <option *ngFor="let person of contacts()" [ngValue]="person.id">
            {{ person.firstName }} {{ person.lastName }} ({{ person.email }})
          </option>
        </select>
      </div>

      <div class="modal-footer border-0">
        <button
          type="button"
          class="btn btn-falcon-default"
          (click)="closeDialog()"
        >
          {{ "general.cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!selectedContactId() || saving()"
          (click)="confirmAssign()"
        >
          {{ "admin.projectIdeas.salesContactCard.assign" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
